<template>
  <div>
    <v-progress-linear v-if="isLoading" indeterminate absolute />
    <div class="d-flex align-center pa-5 custom-container">
      <p class="title mb-0">{{ monthAndYear }}</p>
      <div class="ml-auto d-flex align-center">
        <v-menu v-model="menu" :close-on-content-click="false" offset-y offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="label"
              v-bind="attrs"
              v-on="on"
              prepend-inner-icon="mdi-calendar-search-outline"
              class="invoices-filter__text body-2"
              hide-details
            />
          </template>
          <v-date-picker
            v-model="date"
            @change="mountDateFilterParams"
            color="primary"
            :locale="localeLanguage"
            type="month"
            no-title
          />
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              class="menu-button"
              v-bind="attrs"
              v-on="on"
              :disabled="isDownloading || !invoicesLength || !filtersReady"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="handleDownload"
              :disabled="isDownloading || !invoicesLength || !filtersReady"
            >
              <v-list-item-icon class="custom-icon">
                <v-icon>mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="custom-title">
                {{ $t('payment.list.actions.downloadNote') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div v-if="downloadError" class="pa-5 pt-0">
      <span class="error-text">
        {{ downloadError }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import store from '@/store';
import moment from 'moment-timezone';
import { catalogReadableMonthAndYear } from '@/util/catalog';

export default {
  name: 'CustomerReceivedInvoicesFilters',

  props: {
    sender: {
      type: String,
      required: true,
    },
    isDownloading: {
      type: Boolean,
      default: false,
    },
    downloadError: {
      type: String,
      default: null,
    },
    invoicesLength: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapGetters(['isLoading', 'filters']),

    localeLanguage() {
      return localStorage.getItem('user_language') ?? 'pt-BR';
    },

    monthAndYear() {
      return this.date ? this.formatMonthAndYear(this.date) : this.formatMonthAndYear(new Date());
    },

    filtersReady() {
      return !!this.filters.creationStartDate && !!this.filters.creationEndDate;
    },
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),
    ...mapActions(['fetchCustomerInvoices']),

    mountDateFilterParams(date) {
      const startMonth = moment(date).startOf('month').format('YYYY-MM-DD') + 'T00:00:00Z';
      const endMonth = moment(date).endOf('month').format('YYYY-MM-DD') + 'T23:59:59Z';

      this.label = moment(startMonth).add(1, 'days').format('DD/MM') + ' ~ ' + moment(endMonth).format('DD/MM');

      const params = {
        creationStartDate: startMonth,
        creationEndDate: endMonth,
      };

      return Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...params })
      )
        .then(() => this.setCurrentPage(1))
        .then(() => this.fetchCustomerInvoices(this.sender));
    },

    handleDownload() {
      this.$emit('downloadInvoiceZip');
    },

    formateDate(date) {
      const dateMoment = moment(date);
      const newDateMoment = dateMoment.clone().subtract(moment.tz.zone(this.timezone).utcOffset(dateMoment), 'minutes');
      const newDateString = newDateMoment.format('YYYY-MM-DDTHH:mm:ss');

      return newDateString + 'Z';
    },
  },

  data() {
    return {
      label: '',
      menu: false,
      timezone: moment.tz.guess(),
      date: new Date().toISOString(),
      formatMonthAndYear: catalogReadableMonthAndYear,
    };
  },

  mounted() {
    this.mountDateFilterParams(this.date);
  },
};
</script>

<style scoped>
.invoices-filter__text {
  width: 140px;
  text-align: center;
  margin-right: -8px;
}

.invoices-filter__text .v-input__prepend-inner {
  transform: scale(.75) !important;
  opacity: 0.75;
}

.custom-container {
  padding-right: 4px !important;
}

div.d-flex.align-center.pa-5 .menu-button {
  width: 24px !important;
  height: 24px !important;
  margin-left: 7px !important;
  margin-top: 18px !important;
}

div.d-flex.align-center.pa-5 .menu-button .v-icon {
  font-size: 22px !important;
}

.error-text {
  color: red;
}

.custom-icon {
  margin-right: 5px !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
}
</style>